const formatBookingId = (id) => (id ? `CB${id.toString().padStart(5, '0')}` : '');

export default formatBookingId;
